import React from 'react';

import { RenderNetworkError } from './RenderNetworkError';
import { RenderSuccess } from './RenderSuccess';
import { RenderError } from './RenderError';

function successCheck(data) {
  return (
    (data?.installed && data?.error?.name !== 'INCORRECT_TRACKING_SCRIPT_INSTALLED') ||
    (data?.installed && !data?.error?.name)
  );
}

export function RenderResult({ data, error, originalUrl, origin }) {
  if (error) {
    return <RenderNetworkError error={error} originalUrl={originalUrl} />;
  }

  if (!data || !originalUrl) {
    return null;
  }

  const installPath = !origin ? '/install' : origin.replace('/check-script', '');

  if (successCheck(data)) {
    return <RenderSuccess data={data} originalUrl={originalUrl} finalUrl={data.finalUrl} installPath={installPath} />;
  }

  if (data?.error?.name) {
    return <RenderError data={data} installPath={installPath} />;
  }
}
